export default "__VITE_ASSET__COcdWgeI__"